var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"logo",attrs:{"to":{name: "sale.title"}}},[_c('v-row',{staticClass:"row-logo"},[_c('img',{staticClass:"py-2 ma-0",attrs:{"alt":"bouquet logo","src":require("@/assets/bouquet-new-logo.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }